<template>
  <section class="w-banner w-banner-one" :class="'uiwubanneractive'+bannerIndex" @mousemove="mouseMove" @mouseleave="mouseLeave">
				<div class="swiper-container">
					<ul class="swiper-wrapper uiwu-box">
						<li class="swiper-slide uiwu-flex" :class="bannerIndex === index ? 'swiper-slide-active':'' " v-for="(item,index) in bannerlist" :key="index">
							<div class="swiper-slide-img">
								<img :src="item.img" alt="">
							</div>
							<div class="swiper-slide-dsc">
								<h2>{{item.title}}</h2>
								<p>{{item.text}}</p>
								<!-- <div class="swiper-slide-dsc-btn">
									<button type="button">Free Download</button>
									<button type="button">Learn More</button>
								</div> -->
							</div>
						</li>
					</ul>
					<!-- 如果需要分页器 -->
					<div class="swiper-pagination">
						<span class="swiper-pagination-item" :class="bannerIndex === index ? 'active':''" v-for="(item,index) in bannerlist" :key="index" @click="ousemoveSwiper(index)"> <!-- @mousemove="ousemoveSwiper(index)"-->
							<svg width="28px" height="28px" class="svg" v-if="index === bannerIndex">
								<circle r="12" cy="14" cx="14" stroke-width="2" stroke="rgba(255,255,255,0)" strokelinejoin="round" stroke-linecap="round" fill="none" />
								<circle v-if="!isShowBtn" class="progress" r="12" cy="14" cx="14" stroke-width="2" stroke="#FFF" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-dashoffset="0px" stroke-dasharray="471px" />
							</svg>
						</span>
					</div>
				</div>
			</section>
</template>

<script>
// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
//  components: {
//     Swiper,
//     SwiperSlide
//   },
//   directives: {
//     swiper: directive
//   },
let t = null;
import 'swiper/css/swiper.css'
export default {
    name:'uiwuIndexBanner',
 
    data(){
        return {
            bannerIndex:0,
            isShowBtn:false,
            bannerlist:[{
                img: "https://www.cisdem.com/image/index/duplicate_finder_icon.png",
                title: 'Duplicate Finder',
                url:'duplicate-finder.html',
                text: '快速精准地查找重复文件并删除它们，清理您的电脑存储空间，让其运行更流畅。同时支持相似图片的查找。',
            },{
                img: "https://www.cisdem.com/image/index/appcrypt_icon.png",
                title: 'AppCrypt',
                url:'duplicate-finder.html',
                text: '电脑App加密，屏蔽网站访问，可用来保护隐私和防网络干扰，也可用于对孩子和雇员的电脑控制及网络监管。',
            },{
				img: "https://www.cisdem.com/image/index/pdf_converter_ocr_icon.png",
                title: 'PDF Converter OCR',
                url:'PDF Converter OCR',
                text: '将扫描的PDF转换为Office、iWork、图片等各种格式，并完美保持其布局。同时支持各种文件格式转换为PDF。',
			},{
				img: "https://www.cisdem.com/image/index/video_converter_icon.png",
                title: 'Video Converter',
                url:'duplicate-finder.html',
                text: '完美的视频处理软件，功能包括几乎所有音视频格式的转换，正版DVD影片转换视频，1000+网站的视频下载。',
			}]
        }
    },
    mounted:function(){
        this.timeSwitch();
    },
    methods:{
        switchImg(e) {
			if (e === 'next') {
				this.bannerIndex++
				if (this.bannerIndex > this.bannerlist.length - 1) {
					this.bannerIndex = 0
				}
			} else {
				this.bannerIndex--
				if (this.bannerIndex < 0) {
					this.bannerIndex = this.bannerlist.length - 1
				}
			}
		},
		mouseMove() {
			clearInterval(t)
			this.isShowBtn = true
		},
		mouseLeave() {
			this.timeSwitch()
			this.isShowBtn = false
		},
		timeSwitch() {
			t = setInterval(() => {
				this.switchImg('next')
			}, 4000)
		},
		ousemoveSwiper(i) {
			this.bannerIndex = i
		}
    }
}
</script>

<style lang="scss" scoped>

$min768: 'min-width:768px';
$min992: 'min-width:992px';
$min1024: 'min-width:1024px';

$border: 2px;
$rW: 20px;
$rH: 20px;
$rR: 10px;
$colorB: #2e0f67;
$colorA: #ffffff;
$setIn: 3s;
    // 轮播图
.w-banner {
	width: 100%;
	min-height: 299px;
	height: 100%;
	max-height: 99999px;
	position: relative;
	background: #2e0f67;
	transition: opacity 1s;
	// background: url(../pages/product/image/AppCrypt%20pc.png) no-repeat 0 0;
	// background-size: cover;
	.swiper-container {
		width: 1270px;
		height: 100%;
		margin: auto;
		@media screen and ($min768) and (max-width: 1024px) {
			width: 100%;
		}
		@media screen and (min-width: 320px) and (max-width: 768px) {
			width: 100%;
		}
		.swiper-wrapper {
			width: 100%;
			height: 100%;
			padding: 100px 0 130px;
			position: relative;
			@media screen and ($min768) and (max-width: 1024px) {
				padding: 60px 0 ;
			}
			@media screen and (min-width: 320px) and (max-width: 767px) {
				padding: 0;
			}
			.swiper-slide {
				width: 100%;
				height: 100%;
				transform: scale(0.9);
				transition: transform 0.3s;
				opacity: 0;
				position: absolute;
				top: 0;
				left: 0;
				padding: 10px 110px 10px 128px;
				// padding: 10px 128px;
				@media screen and ($min768) and (max-width: 1024px) {
					padding: 0 40px;
				}
				@media screen and (min-width: 320px) and (max-width: 767px) {
					flex-wrap: wrap;
					padding: 1.12rem 1.06rem;
					justify-content: center;
				}
				&.swiper-slide-active {
					opacity: 1;
					transform: scale(1);
					transition: transform 0.3s;
					transform: translate3d(0px, 0px, 0px);
					position: static;
					z-index: 3;
				}
				&-img {
					width: auto;
					height: 238px;
					img{
						width: 248px;
						height: auto;
					}
					@media screen and ($min768) and (max-width: 1024px) {
						margin-right: 50px;
					}
					@media screen and (min-width: 320px) and (max-width: 767px) {
						width: calc(100% /1);
						height: auto;
						img {
							margin: auto;
							width: calc(248px / 2 );
						}
					}
				}
				&-dsc {
					margin-left: 107px;
					flex: 1;
                    justify-content: center;
                    display: flex;
                    flex-direction: column;
					@media screen and ($min768) and (max-width: 1024px) {
						margin: 0;
						width: calc(100% / 1);
						flex: initial;
					}
					@media screen and (min-width: 320px) and (max-width: 767px) {
						margin: 0;
						width: calc(100% / 1);
						flex: initial;
					}
					h2 {
						font-size: 49px;
						font-weight: bold;
						color: #fff;
                        margin-bottom: 21px;
						white-space: nowrap;
						@media screen and ($min768) and (max-width: 1024px) {
							font-size: 46px;
							margin-bottom: 21px;
						}
						@media screen and (min-width: 320px) and (max-width: 767px) {
							font-size: .6133rem;
							margin: 1.05rem 0 0.49rem 0;
                            text-align: left;
						}
					}
					p {
						font-size: 18px;
						color: #fff;
						font-weight: 100;
                         line-height: 1.5;
						@media screen and ($min768) and (max-width: 1024px) {
							font-size: 18px;
						}
						@media screen and (min-width: 320px) and (max-width: 767px) {
							font-size: .3467rem;
                            text-align: left;
                           
						}
					}
					&-btn {
						margin-top: 54px;
						@media screen and ($min768) and (max-width: 1024px) {
							margin-top: 0.5rem;
						}
						@media screen and (min-width: 320px) and (max-width: 767px) {
							margin-top: 1.24rem;
						}
						button {
							width: 160px;
							height: 48px;
							border-radius: 10px;
							color: #fff;
							font-size: 18px;
							transition: all 0.3s;
							cursor: pointer;
							font-weight: 500;
							@media screen and (min-width: 320px) and (max-width: 767px) {
								width: 100%;
								height: 1.17rem;
							}
							&:nth-child(1) {
								background-color: #06c668;
								margin-right: 30px;
								@media screen and (min-width: 320px) and (max-width: 767px) {
									margin-bottom: 0.3rem;
								}
							}
							&:nth-child(2) {
								background-color: transparent;
								border: 2px solid #ffffff;
							}
							&:nth-child(2):hover {
								color: #0ad482;
								border-color: #0ad482;
							}
							&:nth-child(1):hover {
								background-color: #0ad482;
								border-color: #0ad482;
							}
						}
					}
				}
			}
		}
	}
	.swiper-button-btn {
		color: #999;
		opacity: 0;
		transition: all 0.2s;
		@media screen and (min-width: 320px) and (max-width: 768px) {
			display: none;
		}
		&.active {
			opacity: 1;
			transition: all 0.2s;
		}
	}
	.swiper-pagination {
		bottom: 30px;
		width: 100%;
		height: 30px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		@media screen and (min-width: 320px) and (max-width: 767px) {
			display: none;
		}
		&-item {
			width: 10px;
			height: 10px;
			background: #fff;
			opacity: 0.5;
			display: inline-block;
			border-radius: 50%;
			margin: 0 10px;
			line-height: 30px;
			&.active {
				opacity: 1;
				position: relative;
				width: 10px;
				height: 10px;
				background-color: transparent;
				display: flex;
				justify-content: center;
				align-items: center;
				&::after{
					content: '';
					width: 10px;
					height: 10px;
					position: absolute;
					left: 0;
					margin: auto;
					top: 0;
					right: 0;
					bottom: 0;
					background: #FFF;
					border-radius: 50%;
				}
			}
		}
		.svg {
			transform: rotate(-90deg);
			position: absolute;
			z-index: 99;
		}
		.progress {
			animation: rotate 25s linear both;
			stroke-dashoffset: 0;
		}
		@keyframes rotate {
			from {
				stroke-dashoffset: 471px;
			}
			to {
				stroke-dashoffset: 0px;
			}
		}
	}
}
.uiwubanneractive0{
	background: url(../../assets/home/banner/DuplicateFinder.png) no-repeat 0 0;
	background-size: cover;
	opacity: 1;
	@media screen and (min-width: 320px) and (max-width: 767px) {
		background: url(../../assets/home/banner/DuplicateFinderios.png)no-repeat 0 0;
		background-size: cover;
	}
	@media screen and ($min768) and (max-width: 1024px) {
		background: url(../../assets/home/banner/DuplicateFinderipad.png) no-repeat 0 0;
		background-size: cover;
	}
}
.uiwubanneractive1{
	background: url(../../assets/home/banner/AppCrypt.png) no-repeat 0 0;
	background-size: cover;
	opacity: 1;
	@media screen and (min-width: 320px) and (max-width: 767px) {
		background: url(../../assets/home/banner/AppCryptios.png)no-repeat 0 0;
		background-size: cover;
	}
	@media screen and ($min768) and (max-width: 1024px) {
		background: url(../../assets/home/banner/AppCryptipad.png) no-repeat 0 0;
		background-size: cover;
	}
}
.uiwubanneractive2{
	background: url(../../assets/home/banner/PDFConverterOCR.png) no-repeat 0 0;
	background-size: cover;
	opacity: 1;
	@media screen and (min-width: 320px) and (max-width: 767px) {
		background: url(../../assets/home/banner/bannerbg@2x.png)no-repeat 0 0;
		background-size: cover;
	}
	@media screen and ($min768) and (max-width: 1024px) {
		background: url(../../assets/home/banner/bannerbg.png) no-repeat 0 0;
		background-size: cover;
	}
}
.uiwubanneractive3{
	background: url(../../assets/home/banner/VideoConverter.png) no-repeat 0 0;
	background-size: cover;
	opacity: 1;
	@media screen and (min-width: 320px) and (max-width: 767px) {
		background: url(../../assets/home/banner/bg@2x.png)no-repeat 0 0;
		background-size: cover;
	}
	@media screen and ($min768) and (max-width: 1024px) {
		background: url(../../assets/home/banner/bg_apid.png) no-repeat 0 0;
		background-size: cover;
	}
}
// .w-banner-three{
// 	background: url(../../assets/home/banner/PDFConverter/bannerbj.png) no-repeat 0 0;
// 	background-size: cover;
// 	opacity: 1;
// 	@media screen and (min-width: 320px) and (max-width: 767px) {
// 		background: url(../../assets/home/banner/PDFConverter/bannerbg@2x.png)no-repeat 0 0;
// 		background-size: cover;
// 	}
// 	@media screen and ($min768) and (max-width: 1024px) {
// 		background: url(../../assets/home/banner/PDFConverter/bannerbg.png) no-repeat 0 0;
// 		background-size: cover;
// 	}
// }
// .w-banner-four{
// 	background: url(../../assets/home/banner/bj.png) no-repeat 0 0;
// 	background-size: cover;
// 	opacity: 1;
// 	@media screen and (min-width: 320px) and (max-width: 767px) {
// 		background: url(../../assets/home/banner/bg@2x.png)no-repeat 0 0;
// 		background-size: cover;
// 	}
// 	@media screen and ($min768) and (max-width: 1024px) {
// 		background: url(../../assets/home/banner/bg_apid.png) no-repeat 0 0;
// 		background-size: cover;
// 	}
// }
  
</style>